module.exports = __webpack_public_path__ + "assets/img/block-hover-be856dd6.png";